import React, { Fragment, useEffect, useState } from 'react';
import { GUTTER_SM, TABLE_COL_MIN_WIDTH_ID } from "../../../styles/constants";
import { Button, Col,  Form,  Modal,  Row, Tooltip } from "antd";
import { BUTTON_DELETE, BUTTON_DETAIL } from "../../../styles/buttons";
import { compose } from "redux";
import { translate } from "react-i18next";
import InfiniteScrollTable from "../../../components/infinite-scroll-table";
import { connect } from 'react-redux';
import ConnectionControl from './connection-control/ConnectionControl';
import { MDMDATABASE, MSSQLSERVER, MYSQL, ORACLE, getConnectionDetail, getDatasets, getDatasetsForMultipleConnections, removeDbdConnections, removeDdbConnection, showConnectionModal, showDetailDdbConnection } from './action';
import _ from 'lodash';

const mapStateToProps = state => ({
    connections: state.scenes.mappingHandler.ddbConnection.shared.connections,
    dataset: state.scenes.mappingHandler.ddbConnection.shared.dataset,
    connectionDetail: state.scenes.mappingHandler.ddbConnection.shared.connectionDetail,
    areDatasetsInConnections: state.scenes.mappingHandler.ddbConnection.shared.areDatasetsInConnections,
    datasetsForAllConnections: state.scenes.mappingHandler.ddbConnection.shared.datasetsForAllConnections,
    username: state.app.user.username,
})

const mapDispatchToProps = dispatch => ({
    onShowConnectionModal: () => dispatch(showConnectionModal()),
    onDeleteConnection: (connection) => dispatch(removeDdbConnection(connection)),
    onDeleteConnections: (connections) => dispatch(removeDbdConnections(connections)),
    onShowDetailDdbConnection: (connectionName, creating) => dispatch(showDetailDdbConnection(connectionName, creating)),
    onGetDatasets: (entityId,username) => dispatch(getDatasets(entityId,username)),
    onGetConnectionDetail: (entityId) => dispatch(getConnectionDetail(entityId)),
    onGetDatasetsForAllConnections: (entityIdArray) => dispatch(getDatasetsForMultipleConnections(entityIdArray))
})

export const convertDbType = (dbType) => {
    let dbTypeDescription = '';
    switch(dbType) {
        case 1:
            dbTypeDescription = MDMDATABASE;
            break;
        case 2:
            dbTypeDescription = MSSQLSERVER;
            break;
        case 3:
            dbTypeDescription = ORACLE;
            break;
        case 4:
            dbTypeDescription = MYSQL;
            break;
        default:
            break;
    }
    return dbTypeDescription;
}

export const convertConnectionType = (connectionType) => {
    let connectionTypeDescription = '';
    switch(connectionType) {
        case 1:
            connectionTypeDescription = "Wallet";
            break;
        case 2:
            connectionTypeDescription = "Basic";
            break;
        default:
            break;
    }
    return connectionTypeDescription;
}

const DdbConnectionList = ({
    t,
    connections,
    onShowConnectionModal,
    onDeleteConnection,
    onDeleteConnections,
    onShowDetailDdbConnection,
    onGetDatasets,
    onGetConnectionDetail,
    connectionDetail,
    onGetDatasetsForAllConnections,
    dataset,
    datasetsForAllConnections,
    areDatasetsInConnections,
    username,
}) => {
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalMultipleDeleteOpen, setIsModalMultipleDeleteOpen] = useState(false);

    /*Modal singola eliminazione*/
    useEffect(() => {
        if(!!isModalDeleteOpen && !!connectionDetail && dataset!== undefined && dataset !== null){
            Modal.confirm({
                title: t('scenes.mappingHandler.DDBConnection.modals.confirms.delete.singleDeleteTitle'),
                onOk() {
                    if(!!dataset && dataset.length >= 1){
                        Modal.info({
                            title:  dataset.length === 1 ? 
                                    t('scenes.mappingHandler.DDBConnection.modals.info.deleteFailed.singleDeleteFailedTitle') :
                                    t('scenes.mappingHandler.DDBConnection.modals.info.deleteFailed.multipleDeleteFailedTitle'), 
                            content: deleteSingleConnectionContent(dataset)
                        })
                    } else {
                        onDeleteConnection(connectionDetail);
                    }
                },
                cancelText: t('commons.buttons.cancel.title')
            })
        setIsModalDeleteOpen(false);
        }
    }, [isModalDeleteOpen, dataset, connectionDetail]);

    const deleteSingleConnectionContent = (dataset) => {
        return <div>
                    <ul>
                        {dataset.map((el,index)=>{
                            return <li key={index}>{el.name}</li>
                        })}
                    </ul> 
                </div>
    }

    /*Modal eliminazione multipla*/
    useEffect(() => {
        if(!!isModalMultipleDeleteOpen && !!connectionDetail && datasetsForAllConnections!== undefined && datasetsForAllConnections !== null) {
            Modal.confirm({
                title:  datasetsForAllConnections.length === 1 ? 
                        t('scenes.mappingHandler.DDBConnection.modals.confirms.delete.singleDeleteTitle') : 
                        t('scenes.mappingHandler.DDBConnection.modals.confirms.delete.multipleDeleteTitle'),
                onOk() {
                    if(!!areDatasetsInConnections){
                        let connectionIdAndName = [];
                        _.forEach(datasetsForAllConnections, (singleDataset) => 
                            {_.filter(connectionDetail, (singleConnection) => 
                                {if(singleDataset.connectionId === singleConnection.entityId)
                                    {connectionIdAndName.push({connectionName: singleConnection.connectionName, entityId: singleConnection.entityId, dataset: singleDataset.datasets})}
                                })
                            }
                        )
                        Modal.info({
                            title: t('scenes.mappingHandler.DDBConnection.modals.info.deleteFailed.multipleDeleteFailedTitle'),
                            content: deleteMultipleConnectionsContent(connectionIdAndName)
                        })
                    } else {
                        onDeleteConnections(connectionDetail);
                    }
                },
                cancelText: t('commons.buttons.cancel.title')
            })
        setIsModalMultipleDeleteOpen(false);
        }
    }, [isModalMultipleDeleteOpen, connectionDetail, datasetsForAllConnections]);

    const deleteMultipleConnectionsContent = (connectionIdAndName) => {
        return  <div>
                    {connectionIdAndName.map((singleConnection,index)=>{
                        return <div key={index}>
                                    <p>{singleConnection.connectionName}:</p>
                                    <ul>
                                        {singleConnection.dataset.map((singleDataset,index)=>{
                                            return <li key={index}>{singleDataset}</li>
                                        })}
                                    </ul>
                                </div>
                    })}
                </div> 
    }

    return (
        <Fragment>
            <InfiniteScrollTable
                data={connections}
                getRowKey={({entityId}) => entityId}
                columns={[
                    {
                        title: t('scenes.mappingHandler.DDBConnection.DDBConnectionTable.connectionName.label'),
                        dataIndex: 'connectionName',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    },
                    {
                        title: t('scenes.mappingHandler.DDBConnection.DDBConnectionTable.dbName.label'),
                        dataIndex: 'database',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    },
                    {
                        title: t('scenes.mappingHandler.DDBConnection.DDBConnectionTable.dbType.label'),
                        dataIndex: 'dbType',
                        render: dbType => convertDbType(dbType),
                        renderText: dbType => convertDbType(dbType),
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    }
                    ]}
                rowSelection={{}} 
                rightActions={
                        <Row type="flex" justify="end" gutter={GUTTER_SM}>
                            <Col>
                            <Tooltip
                                title={t("scenes.mappingHandler.DDBConnection.tooltip.createNewConnection")}>
                                <Button 
                                    icon="plus"
                                    type="primary"
                                    onClick={() => onShowDetailDdbConnection(null, true)}
                                >
                                {t('commons.buttons.create.title')}
                                </Button>
                            </Tooltip>
                                
                            </Col> 
                        </Row>
                }  
                actions= {[]
                    .concat(
                        () => ({
                            ...BUTTON_DETAIL,
                            title: t('commons.actions.detail.title'),
                            onClick: (row) => {
                                onShowDetailDdbConnection(row, false);
                            }
                        }) 
                    )
                    .concat(
                        () => ({
                            ...BUTTON_DELETE,
                            title: t('commons.actions.delete.title'),
                            onClick: ({entityId}) => {
                                onGetDatasets(entityId,username);
                                onGetConnectionDetail(entityId);
                                setIsModalDeleteOpen(true);
                            }
                        }) 
                    )
                } 
                tableActions={[
                    {
                        title:t('commons.buttons.delete.title'),
                        icon:'delete',
                        onClick:(connections,deselect) => {
                            const entityIdArray = [];
                            const entityIdArrayAsNumbers = [];
                            _.forEach(connections, (singleConn) => entityIdArray.push(singleConn.entityId));
                            _.forEach(entityIdArray, (eachEntity) => entityIdArrayAsNumbers.push(Number(eachEntity)));
                            onGetDatasetsForAllConnections(entityIdArrayAsNumbers);
                            onGetConnectionDetail(entityIdArray);
                            setIsModalMultipleDeleteOpen(true);
                            deselect();
                        }
                    }
                ]}
            >
                
            </InfiniteScrollTable>
            <ConnectionControl  />
        </Fragment>
    )

}

export default compose(
    translate(),
    connect(mapStateToProps,mapDispatchToProps),
    Form.create()
)(DdbConnectionList);